import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { subscribeNewsletter } from '../../api/subscriberApi';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import LanguageContext from '../../context/LanguageContext';
import './Subscribe.css';
import Button from '../../components/UI/Button/Button';

const Subscribe = () => {
    const { dir } = useContext(LanguageContext);
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle');
    const [message, setMessage] = useState('');

    const handleSubscribe = async (e) => {
        e.preventDefault();
        if (!email.trim()) return;

        setStatus('loading');
        setMessage('');

        try {
            const result = await subscribeNewsletter(email.trim(), 'subscribe-page');
            setStatus('success');
            setMessage(result.message || t('subscribe.success'));
            setEmail('');
        } catch (error) {
            setStatus('error');
            setMessage(error.message || t('subscribe.error'));
        }
    };

    return (
        <main className="main">
            <Breadcrumb title={t('subscribe.title')} />

            <section className="subscribe-page">
                <div className="container subscribe-body" dir={dir()}>
                    <div className="subscribe-card">
                        {status === 'success' ? (
                            <div className="subscribe-result subscribe-result--success">
                                <div className="subscribe-success-visual" aria-hidden="true">
                                    <span className="subscribe-success-icon">&#10003;</span>
                                </div>
                                <h2 className="subscribe-title">{t('subscribe.doneTitle')}</h2>
                                <p className="subscribe-lead">{message}</p>
                            </div>
                        ) : (
                            <>
                                <h2 className="subscribe-title">{t('subscribe.title')}</h2>
                                <p className="subscribe-lead">{t('subscribe.description')}</p>

                                <form className="subscribe-form" onSubmit={handleSubscribe} noValidate>
                                    <div className="subscribe-field">
                                        <label className="subscribe-label" htmlFor="subscribe-email">
                                            {t('subscribe.emailLabel')}
                                        </label>
                                        <input
                                            id="subscribe-email"
                                            type="email"
                                            className="subscribe-input"
                                            placeholder={t('subscribe.emailPlaceholder')}
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            disabled={status === 'loading'}
                                            autoComplete="email"
                                        />
                                    </div>
                                    <Button
                                        type="submit"
                                        className="subscribe-submit"
                                        disabled={status === 'loading' || !email.trim()}
                                    >
                                        {status === 'loading'
                                            ? t('subscribe.processing')
                                            : t('subscribe.confirm')}
                                    </Button>
                                </form>

                                {status === 'error' && (
                                    <p className="subscribe-alert" role="alert">
                                        {message}
                                    </p>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Subscribe;
